export default __webpack_public_path__ + "static/media/kbc_icon_purple.d1ba96f9.svg";